export function formatNumber(
  value: number,
  maximumFractionDigits: number = 0,
  minimumFractionDigits: number = 0,
) {
  if (value) return value.toLocaleString('da-DK', { maximumFractionDigits, minimumFractionDigits });
  else return value;
}
